var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-template", [
    _c(
      "div",
      { staticClass: "pdf-wrap" },
      [
        _vm.showCustomDownloadIcon
          ? _c(
              "div",
              {
                attrs: { id: "pdf-download" },
                on: { click: _vm.downloadFile },
              },
              [
                _c("img", {
                  staticClass: "hover",
                  attrs: { src: _vm.ic_pdf_download, width: "20" },
                }),
              ]
            )
          : _vm._e(),
        _vm.bolJson
          ? _c(
              "VueHtml2pdf",
              {
                ref: "html2Pdf",
                attrs: {
                  "show-layout": false,
                  "float-layout": true,
                  "enable-download": false,
                  "preview-modal": true,
                  "paginate-elements-by-height": 1400,
                  "pdf-quality": 2,
                  "manual-pagination": true,
                  "pdf-format": "a4",
                  "pdf-orientation": "p",
                  "pdf-content-width": "100%",
                  filename: _vm.fileName,
                },
                on: {
                  beforeDownload: function ($event) {
                    return _vm.beforeDownload($event)
                  },
                  hasDownloaded: function ($event) {
                    return _vm.hasDownloaded($event)
                  },
                },
              },
              [
                _c(
                  "section",
                  { attrs: { slot: "pdf-content" }, slot: "pdf-content" },
                  [
                    _c("rate-con-printable", {
                      attrs: {
                        shipment: _vm.bolJson,
                        hazmatClasses: _vm.hazmatClassesJson,
                        referenceTypes: _vm.referenceTypesJson,
                        multiStopOrders: _vm.multiStopOrdersComputed,
                        miles: _vm.miles,
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _c(
          "v-overlay",
          {
            attrs: {
              value: _vm.showLoadingScreenComputed,
              opacity: "0.9",
              color: "#fff",
            },
          },
          [
            _c(
              "v-row",
              { staticClass: "mt-n16" },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "text-center",
                    class: { "px-6": _vm.smAndDown },
                  },
                  [
                    _c("img", {
                      staticClass: "rotating",
                      attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                    }),
                    _c("p", { staticClass: "overlay-txt mt-5" }, [
                      _vm._v(" " + _vm._s(_vm.loadingScreenMessage) + " "),
                    ]),
                    _vm.multiStopOrderIdsComputed.length
                      ? _c("img", {
                          attrs: { src: _vm.ic_consolidate, width: "86" },
                        })
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }